import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { useDataContext } from "../contexts/dataContext";

export default function Menu() {
    const { setUsuario } = useDataContext()
    const params = useParams()

    const cargarUsuario = async (id) => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/${id}`)
        const data = await res.json()
        //console.log(`usuario logueado ${JSON.stringify(data)}`)
        setUsuario({ ...data })
    }

    const cargarStorage = async () => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT_LOGIN}/usuarios/storage/${params.idStorage}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        }

        )
        if (res.status === 404) {
            //console.log('regresó 404 No hay sesión iniciada')
            // return { idPlanPresupuestal: 0, montoMaximo: 0 }
        }
        else {
            const data = await res.json()
            //console.log(`la sesión existe ${JSON.stringify(data)}`)

            Object.entries(JSON.parse(data.storage)).forEach(([key, value]) => {
                sessionStorage.setItem(key, value)

            })
            // navigate('/11')

            const token = sessionStorage.getItem('token')
            const decoded = jwt_decode(token);
            const id = decoded.id;
            
            
            await cargarUsuario(id)
            window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT}/`)
        }
    }

    useEffect(() => {
        (async () => {
            await cargarStorage()

        })();
    }, []);



    return (

        <Grid container direction='row' justifyContent='center' spacing={1} style={{ marginTop: 50 }}>
            {/* <Grid item xs={12} sm={4}>
                <Card style={{ height: '100%' }}>
                    <CardHeader title='Gestión presupuestal'></CardHeader>
                    <CardContent>
                        <Grid container direction='row'>
                            <Grid xs={12} sm={3}>
                                <Button variant="outlined" color='secondary' sx={{ marginRight: 2 }}><PriceChangeTwoToneIcon sx={{ fontSize: '50px' }}></PriceChangeTwoToneIcon></Button>
                            </Grid>
                            <Grid xs={12} sm={8}>
                                Gestión el ejercicio presupuestal de la unidad.
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} sm={4}>
                <Card style={{ height: '100%' }}>
                    <CardHeader title='Buzón UAM-L'></CardHeader>
                    <CardContent>
                        <Grid container direction='row'>
                            <Grid xs={12} sm={3}>
                                <Button variant="outlined" color='secondary' sx={{ marginRight: 2 }}><MarkAsUnreadTwoToneIcon sx={{ fontSize: '50px' }}></MarkAsUnreadTwoToneIcon></Button>
                            </Grid>
                            <Grid xs={12} sm={8}>
                                Evaluación de servicios / Eventualidades de violencia de género
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
    </Grid>*/}
        </Grid>

    )
}